import Link from 'next/link'
import styled from 'styled-components'

export const ListItem = styled.li`
  padding: 20px 0;
  border-bottom: 1px solid var(--grey-25);

  svg {
    width: 28px;
    height: 28px;
    position: relative;
    flex-shrink: 0;
  }

  p {
    margin: 0;
    font-weight: var(--font-regular);
    font-size: 16px;
    line-height: 1.6;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  line-height: 1.5;
  font-size: 20px;
  font-weight: var(--font-medium);

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

export const CommentLink = styled(Link)`
  background: #e4f3fd;
  border: 1px solid #92c8ec;
  color: #1a8ad4;
  text-decoration-color: #1a8ad4;
  padding: 15px 20px;
  border-radius: 4px;
  font-size: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: fit-content;

  svg {
    width: 24px;
    height: 24px;
    stroke: #1a8ad4;

    rect {
      stroke: #1a8ad4;
    }
  }

  @media (max-width: 768px) {
    padding: 10px 14px;
    font-size: 14px;
  }
`
